import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { UNORDERED_HORIZONTAL_LIST_BASE_CLASSNAME } from './Constants';
import { createUnorderedHorizontalList } from './UnorderedHorizontalList';
createComponents(".".concat(UNORDERED_HORIZONTAL_LIST_BASE_CLASSNAME), createUnorderedHorizontalList, NO_PATTERN_BUSINESS_LOGIC);
